<!--
 * @Author: your name
 * @Date: 2020-06-30 15:07:54
 * @LastEditTime: 2020-08-12 10:28:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\payMent\searchResult\searchResult.vue
-->
<template>
  <div style="width: 100%; height: 100%">
    <div v-if="showContract == 1" class="searchResult-wrap" v-cloak>
      <Contract :showContract.sync="showContract"> </Contract>
    </div>
    <div
      v-show="showContract == 0"
      class="searchResult-wrap"
      v-loading="loading"
      element-loading-text="正在查询您的缴费信息，请稍等"
    >
      <div style="height: 70%">
        <div class="searchResult-back"></div>
        <div class="searchResult-top">
          <div class="searchResult-box">
            <div class="searchResult-box-top">
              <div>房屋卡号：{{ cardCode }}</div>
              <div>
                房屋地址：{{ houseInfo.building_name }}{{ houseInfo.unit_number }}-{{
                  houseInfo.hourse_number
                }}
              </div>
              <div>供热面积：{{ payInfo.area }}m²</div>
              <div>应缴热费：{{ payInfo.area_cost }}元</div>
              <div>上期余额：{{ payInfo.last_surplus }}元</div>
              <div v-if="payInfo.contract_damages_money">
                违约金：{{ payInfo.contract_damages_money }}元
              </div>
              <div class="searchResult-box-select" v-if="insuranceFlag">
                <div>房屋跑漏险：{{ insurance }}元</div>
                <div @click="checkFlagBtn(false)" v-if="checkFlag" style="width: 0.2rem">
                  <img
                    src="../../../assets/image/selected-icon.png"
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div @click="checkFlagBtn(true)" v-else style="width: 0.2rem; height: 0.2rem">
                  <img
                    src="../../../assets/image/outcheck-icon.png"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </div>
            </div>
            <div class="searchResult-box-bottom">
              <div style="margin-top: 10%">合计应交</div>
              <div style="font-size: 24px; margin-top: 3%">
                {{ payInfo.receivable ? (payInfo.receivable + userInsurance).toFixed(2) : '' }}元
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="searchResult-btn-bottom">
        <div>
          <el-button
            type="primary"
            style="background: #007b83; border: none"
            :disabled="enterDisabled"
            @click="payMentSure"
            >确认</el-button
          >
        </div>
        <div>
          <el-button
            type="primary"
            style="
              background: rgba(0, 123, 131, 0.1);
              border: 1px solid #007b83;
              margin-top: 5.5%;
              color: #007b83;
            "
            @click="payMentExit"
            >取消</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contract from '@/components/contract/contract.vue';
export default {
  components: {
    Contract,
  },
  data() {
    return {
      showContract: null,
      cardCode: '', // 卡号
      phone: '', //电话
      houseInfo: '', //房屋信息
      payInfo: {}, //缴费信息
      checkFlag: true, //是否选中
      userInsurance: 0, //用户的跑漏险金额
      insurance: '', //跑漏险
      loading: true,
      insuranceFlag: true,
      userName: '',
      enterDisabled: false,
    };
  },

  methods: {
    // 获取合同
    async getWxHeatContract() {
      const res = await this.$http.get(this.$url.globalurl + '/wxHeatContract');
      console.log(res);
      if (res.result) {
        this.showContract = 0;
      } else {
        this.showContract = 1;
      }
    },
    // 查询应该缴费的信息
    async getPaySearch() {
      // 房屋信息
      const houseRes = await this.$http.get(this.$url.globalurl + '/wxHouseInfo', {
        data: {
          cardCode: this.cardCode,
        },
      });
      this.houseInfo = houseRes.result;
      // 跑漏险金额
      const insuranceResult = await this.$http.get(this.$url.globalurl + '/wxPayMent/0', {
        data: {
          risk: true,
        },
      });
      if (insuranceResult.result.can_paid) {
        const insuranceRes = await this.$http.get(
          this.$url.globalurl + `/systemConfig/${sessionStorage.getItem('customer_id')}`,
          {}
        );
        this.insurance = insuranceRes.result[0].leakage_risk_fee;
        this.userInsurance = insuranceRes.result[0].leakage_risk_fee;
        this.insuranceFlag = true;
      } else {
        this.insuranceFlag = false;
        this.checkFlag = false;
      }

      this.loading = false;
      // 应缴纳费用信息
      const payRes = await this.$http.get(this.$url.globalurl + '/wxPayInfo');
      this.payInfo = payRes.result;
    },
    // 缴费成功跳转
    async payMentSure() {
      if (this.checkFlag) {
        this.$router.replace({
          name: 'insurance',
          query: {
            cardCode: this.cardCode,
            phone: this.phone,
            building_name: this.houseInfo.building_name,
            areaCost: this.payInfo.receivable, //后面显示的是取暖费，而不是面积热费
            insurance: this.insurance,
            payFlag: true,
            userName: this.userName,
          },
        });
      } else {
        this.enterDisabled = true;
        const payRes = await this.$http.post(`${this.$url.globalurl}/placeOrder/`, {
          phone: this.phone,
          card_number: this.cardCode,
          pay_heating: 1,
        });
        WeixinJSBridge.invoke('getBrandWCPayRequest', payRes.result, (res) => {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            this.$router.replace({
              name: 'paySucceed',
              query: {
                houseInfo: this.houseInfo,
                areaCost: this.payInfo.receivable, //后面显示的是取暖费，而不是面积热费
                insuranceMoney: this.insurance,
                payFlag: this.checkFlag,
              },
            });
          }
          this.enterDisabled = false;
        });
      }
    },
    // 取消缴费
    payMentExit() {
      this.$router.replace({
        name: 'index',
        query: {
          cardCode: this.cardCode,
          phone: this.phone,
        },
      });
    },
    // 跑漏险选择
    checkFlagBtn(flag) {
      this.checkFlag = flag;
      flag ? (this.userInsurance = this.insurance) : (this.userInsurance = 0);
    },
  },
  created() {
    this.loading = true;
  },
  async mounted() {
    this.getWxHeatContract();
    if (this.$route.query) {
      this.cardCode = this.$route.query.cardCode;
      this.phone = this.$route.query.phone;
      this.userName = this.$route.query.userName;
    }
    this.getPaySearch();
    document.title = '查询结果';
  },
};
</script>

<style lang="scss" scoped>
@import url(searchResult.scss);
</style>